export const rigLabel = (isBoat: boolean, isCamperLength: boolean, lengthUnit: string): string => {
  if (isBoat) {
    return "boat";
  } else if (lengthUnit === "metric") {
    return "caravan";
  } else if (isCamperLength) {
    return "camper";
  } else {
    return "rig";
  }
}
